import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pickupEndPoint } from 'src/app/utils/constants/requestUrl';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PickupsService {
  post() {
    throw new Error('Method not implemented.');
  }
  constructor(private http: HttpClient) {}

  getPickupList(data): Observable<any> {
    return this.http.post(`${environment.AddressUrl}${pickupEndPoint.getPickupList}`, data);
  }
  bookPickups(data): Observable<any> {
    return this.http.post(`${environment.AddressUrl}${pickupEndPoint.bookPickup}`, data);
  }

  cancelPickup(requestBody) {
    return this.http.delete(`${environment.AddressUrl}${pickupEndPoint.cancelPickup}`, requestBody);
  }
}
